<template>
  <div class="p-4">
    <h1 class="text-2xl font-bold mb-4">User Role Management</h1>

    <div v-if="loading" class="text-gray-500">Loading users...</div>
    <div v-else-if="error" class="text-red-600">Error: {{ error }}</div>

    <table v-if="users.length" class="min-w-full border border-gray-300 mt-4">
      <thead class="bg-gray-100">
        <tr>
          <th class="px-4 py-2 text-left">Name</th>
          <th class="px-4 py-2 text-center">Customer</th>
          <th class="px-4 py-2 text-center">Repairmen</th>
          <th class="px-4 py-2 text-center">Admin</th>
          <th class="px-4 py-2 text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user.aai_id" class="border-t">
          <td class="px-4 py-2">
            {{ user.name }} {{ user.surname }}<br />
            <small class="text-gray-500">{{ user.email }}</small>
          </td>
          <td class="text-center">
            <input type="checkbox" :checked="user.customer" disabled />
          </td>
          <td class="text-center">
            <input type="checkbox" v-model="user.repairmen" />
          </td>
          <td class="text-center">
            <input type="checkbox" v-model="user.admin" />
          </td>
          <td class="text-center">
            <button
              class="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
              @click="updateUserRoles(user)"
            >
              Update
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios'
import keycloak from '@/keycloak'
import { backendUrl } from '@/config/envVariablesConfig'

export default {
  name: 'AdminPage',
  data() {
    return {
      users: [],
      loading: true,
      error: null,
    }
  },
  created() {
    this.fetchUsers()
  },
  methods: {
    async fetchUsers() {
      try {
        const res = await axios.get(`${backendUrl}/api/admin/users`, {
          headers: {
            Authorization: `Bearer ${keycloak.token}`,
          },
        })
        this.users = res.data.data
      } catch (err) {
        this.error = err.response?.data?.error || err.message
      } finally {
        this.loading = false
      }
    },
    async updateUserRoles(user) {
      try {
        console.log('Updating roles for user:', JSON.stringify(user));
        
        await axios.post(
          `${backendUrl}/api/admin/users/groups`,
          {
            userid: user.id,
            aaid: user.aai_id,
            customer: user.customer,
            repairmen: user.repairmen,
            admin: user.admin,
          },
          {
            headers: {
              Authorization: `Bearer ${keycloak.token}`,
            },
          }
        )
        alert('User roles updated successfully.')
      } catch (err) {
        console.error('Error updating roles:', err)
        alert('Failed to update roles.')
      }
    },
  },
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}
th, td {
  border: 1px solid #e5e7eb;
}
</style>
